export default __webpack_public_path__ + "static/media/contact.b0835135.svg";